import { render, staticRenderFns } from "./totalDetail.vue?vue&type=template&id=12d4492e&scoped=true"
import script from "./totalDetail.vue?vue&type=script&lang=js"
export * from "./totalDetail.vue?vue&type=script&lang=js"
import style0 from "./totalDetail.vue?vue&type=style&index=0&id=12d4492e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4492e",
  null
  
)

export default component.exports